import React from "react";

export default function Watermark({ word }) {
  return (
    <span className="mt-watermark" aria-hidden="true" data-testid={`watermark-${word.toLowerCase()}`}>
      {word}
    </span>
  );
}
